/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Cubrid API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseCommandResponseMessage,
  ApiResponseCubridActiveSessionResponse,
  ApiResponseCubridInfoResponse,
  ApiResponseCubridLockResponse,
  ApiResponseCubridSqlTextResponse,
  GetV8CubridActiveSessionByInstanceIdParams,
  GetV8CubridLockByInstanceIdParams,
  GetV8CubridSqlTextParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Cubrid 정보 조회
 */
export const getV8CubridInfoByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ApiResponseCubridInfoResponse>(
    { url: `/api/v8/cubrid/info/${instanceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV8CubridInfoByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v8', 'cubrid', 'info', instanceId] as const;
};

export const getGetV8CubridInfoByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8CubridInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8CubridInfoByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8CubridInfoByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8CubridInfoByInstanceId>>> = ({
    signal,
  }) => getV8CubridInfoByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV8CubridInfoByInstanceId>>, TError, TData>;
};

export type GetV8CubridInfoByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8CubridInfoByInstanceId>>
>;
export type GetV8CubridInfoByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Cubrid 정보 조회
 */

export function useGetV8CubridInfoByInstanceId<
  TData = Awaited<ReturnType<typeof getV8CubridInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8CubridInfoByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8CubridInfoByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Cubrid 세션 강제 종료
 */
export const postV8CubridKillSessionByInstanceId = (
  instanceId: MaybeRef<string>,
  postV8CubridKillSessionByInstanceIdBody: MaybeRef<number[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  postV8CubridKillSessionByInstanceIdBody = unref(postV8CubridKillSessionByInstanceIdBody);

  return customAxiosInstance<ApiResponseCommandResponseMessage>(
    {
      url: `/api/v8/cubrid/kill-session/${instanceId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postV8CubridKillSessionByInstanceIdBody,
      signal,
    },
    options,
  );
};

export const getPostV8CubridKillSessionByInstanceIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8CubridKillSessionByInstanceId>>,
    TError,
    { instanceId: string; data: BodyType<number[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8CubridKillSessionByInstanceId>>,
  TError,
  { instanceId: string; data: BodyType<number[]> },
  TContext
> => {
  const mutationKey = ['postV8CubridKillSessionByInstanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8CubridKillSessionByInstanceId>>,
    { instanceId: string; data: BodyType<number[]> }
  > = (props) => {
    const { instanceId, data } = props ?? {};

    return postV8CubridKillSessionByInstanceId(instanceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8CubridKillSessionByInstanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8CubridKillSessionByInstanceId>>
>;
export type PostV8CubridKillSessionByInstanceIdMutationBody = BodyType<number[]>;
export type PostV8CubridKillSessionByInstanceIdMutationError = ErrorType<unknown>;

/**
 * @summary Cubrid 세션 강제 종료
 */
export const usePostV8CubridKillSessionByInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8CubridKillSessionByInstanceId>>,
      TError,
      { instanceId: string; data: BodyType<number[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8CubridKillSessionByInstanceId>>,
  TError,
  { instanceId: string; data: BodyType<number[]> },
  TContext
> => {
  const mutationOptions = getPostV8CubridKillSessionByInstanceIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Cubrid Sql Text 조회
 */
export const getV8CubridSqlText = (
  params: MaybeRef<GetV8CubridSqlTextParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseCubridSqlTextResponse>(
    { url: `/api/v8/cubrid/sql-text`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8CubridSqlTextQueryKey = (params?: MaybeRef<GetV8CubridSqlTextParams>) => {
  return ['api', 'v8', 'cubrid', 'sql-text', ...(params ? [params] : [])] as const;
};

export const getGetV8CubridSqlTextQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8CubridSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8CubridSqlTextParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8CubridSqlText>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8CubridSqlTextQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8CubridSqlText>>> = ({ signal }) =>
    getV8CubridSqlText(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8CubridSqlText>>,
    TError,
    TData
  >;
};

export type GetV8CubridSqlTextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8CubridSqlText>>
>;
export type GetV8CubridSqlTextQueryError = ErrorType<unknown>;

/**
 * @summary Cubrid Sql Text 조회
 */

export function useGetV8CubridSqlText<
  TData = Awaited<ReturnType<typeof getV8CubridSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV8CubridSqlTextParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8CubridSqlText>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8CubridSqlTextQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Cubrid Active Session 조회
 */
export const getV8CubridActiveSessionByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8CubridActiveSessionByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseCubridActiveSessionResponse>(
    {
      url: `/api/v8/cubrid/${instanceId}/active-session`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV8CubridActiveSessionByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV8CubridActiveSessionByInstanceIdParams>,
) => {
  return [
    'api',
    'v8',
    'cubrid',
    instanceId,
    'active-session',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV8CubridActiveSessionByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8CubridActiveSessionByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8CubridActiveSessionByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8CubridActiveSessionByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8CubridActiveSessionByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8CubridActiveSessionByInstanceId>>
  > = ({ signal }) =>
    getV8CubridActiveSessionByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8CubridActiveSessionByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8CubridActiveSessionByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8CubridActiveSessionByInstanceId>>
>;
export type GetV8CubridActiveSessionByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Cubrid Active Session 조회
 */

export function useGetV8CubridActiveSessionByInstanceId<
  TData = Awaited<ReturnType<typeof getV8CubridActiveSessionByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8CubridActiveSessionByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8CubridActiveSessionByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8CubridActiveSessionByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Cubrid Lock 조회
 */
export const getV8CubridLockByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8CubridLockByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseCubridLockResponse>(
    { url: `/api/v8/cubrid/${instanceId}/lock`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8CubridLockByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV8CubridLockByInstanceIdParams>,
) => {
  return ['api', 'v8', 'cubrid', instanceId, 'lock', ...(params ? [params] : [])] as const;
};

export const getGetV8CubridLockByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8CubridLockByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8CubridLockByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8CubridLockByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8CubridLockByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8CubridLockByInstanceId>>> = ({
    signal,
  }) => getV8CubridLockByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV8CubridLockByInstanceId>>, TError, TData>;
};

export type GetV8CubridLockByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8CubridLockByInstanceId>>
>;
export type GetV8CubridLockByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary Cubrid Lock 조회
 */

export function useGetV8CubridLockByInstanceId<
  TData = Awaited<ReturnType<typeof getV8CubridLockByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV8CubridLockByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8CubridLockByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8CubridLockByInstanceIdQueryOptions(instanceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
